export default __webpack_public_path__ + "static/media/YFI.5a75a439.png";